import Vue from "vue";
import VueSwiper from "vue-awesome-swiper";

Vue.use(VueSwiper);
